define('SageDotCom/Components/PartnerSearch',["jquery", 
    "underscore",
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/buttonClick',
    'SageDotCom/DataLayer/Events/findPartnerSearch',
    "eventManager",
    "text!SageDotCom/Components/Templates/PartnerSearchForm.html"],
    function ($, _, tealium, buttonClickEvent, findPartnerSearch, eventManager, partnerSearchFormTemplate) {

        
        function PartnerSearch(scope, contextLanguage, isMetric, metric, metricUnits, distances, defaultDistance, partnerSearchTitle, locationLabel, locationPlaceholder,
            locationValidationMessage, partnerTypes, distanceLabel, businessNameLabel, businessNamePlaceholder, partnerTypeLabel, partnerTypePlaceholder,
            partnerTypeValidationMessage, partnerTypeRequired, submitButtonName, useMyLocationLabel, territory, useRegionBias, countryLabel, countries, alternateLayout) {
            var $partnerSearchFormTemplateDiv = $(".js-partner-search-form-template", scope);
            var options = {
                distances: [],
                partnerTypes: [],
                alternateLayout: alternateLayout
            };
            var metricValue = metric == '' ? (isMetric ? 'Kilometres' : 'Miles') : metric;
            var partnerTypeVal = partnerTypeRequired === '1' ? true : false;
            var distanceUnit = metricUnits.replace("{0}", "").trim();

            var submittedFormData = {
                location: '',
                longitude: null,
                latitude: null,
                distance: null,
                businessName: '',
                partnerType: null,
                productType: null,
                unit: metricValue,
                territory: territory,
                metricUnits: distanceUnit
            }

            // convert underscore to mustache syntax
            _.templateSettings.interpolate = /\{\{(.+?)\}\}/g;
            fillInDistanceOptionsData();
            fillInCountryOptionsData();
            fillInPartnerTypesOptionsData();
            var currTemplate = partnerSearchFormTemplate.replace(/#DistanceLabel#/g, distanceLabel);
            currTemplate = currTemplate.replace("#PartnerSearchTitle#", partnerSearchTitle);
            currTemplate = currTemplate.replace("#LocationLabel#", locationLabel);
            currTemplate = currTemplate.replace("#LocationPlaceholder#", locationPlaceholder);
            currTemplate = currTemplate.replace("#LocationValidationMessage#", locationValidationMessage);
            currTemplate = currTemplate.replace("#CountryLabel#", countryLabel);
            currTemplate = currTemplate.replace("#BusinessNameLabel#", businessNameLabel);
            currTemplate = currTemplate.replace("#BusinessNamePlaceholder#", businessNamePlaceholder);
            currTemplate = currTemplate.replace(/#PartnerTypeLabel#/g, partnerTypeLabel);
            currTemplate = currTemplate.replace(/#PartnerTypePlaceholder#/g, partnerTypePlaceholder);
            currTemplate = currTemplate.replace(/#PartnerTypeValidationMessage#/g, partnerTypeValidationMessage);
            currTemplate = currTemplate.replace("#SubmitButtonName#", submitButtonName);
            currTemplate = currTemplate.replace("#UseMyLocationLabel#", useMyLocationLabel);
            
            var _partnerSearchFormTemplate = _.template(currTemplate);
            var html = "";
            html += _partnerSearchFormTemplate(options);
            $partnerSearchFormTemplateDiv.html(html);
            $('.location-error-message').hide();
            $('.partnertype-error-message').hide();

            var $partnerSearchLocationInput = $("#partner-search-location", scope);
            var $partnerSearchDistanceInput = $("#partner-search-distance", scope);
            var $partnerSearchCountryInput = $("#partner-search-country", scope);
            var $partnerSearchPartnerTypeInput = $("#partner-search-partner-type", scope);
            var $partnerSearchBusinessNameInput = $("#partner-search-business-name", scope);

            var $locationTextBox = $('#partner-search-location', scope);
            var $getLocationHyperlink = $("#get-location", scope);

            $locationTextBox.on("change keyup paste click", function() {
                submittedFormData.longitude = null;
                submittedFormData.latitude = null;
            });

            $getLocationHyperlink.click(function () {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(processLocation, processError);
                } else {
                    alert('Geo location failed');
                }
                var data = buttonClickEvent.GenerateEventMetadata(event.currentTarget);
                tealium.event(data);
            });

            function fillInDistanceOptionsData() {
                options.distances = _.map(distances, function (distance) {
                    return { value: distance, selectedTag: (defaultDistance==distance)?"selected":"", text: metricUnits.replace("{0}", distance) }
                });
            }

            function fillInCountryOptionsData() {
                options.countries = _.map(countries,
                    function (country, index) {
                        var splitStr = country.split("|");
                        return { value: splitStr[0], selectedTag: (index === 0) ? "selected" : "", text: splitStr[1] }
                    });
            }

            function fillInPartnerTypesOptionsData() {
                options.partnerTypes = partnerTypes;
            }

            function processLocation(position) {
                submittedFormData.location = '';
                submittedFormData.longitude = position.coords.longitude;
                submittedFormData.latitude = position.coords.latitude;
                submittedFormData.distance = $partnerSearchDistanceInput.val();
                submittedFormData.businessName = $partnerSearchBusinessNameInput.val();
                submittedFormData.partnerType = $partnerSearchPartnerTypeInput.val();
                submittedFormData.country = $partnerSearchCountryInput.val();
                eventManager.trigger("partner-search-triggered", scope, submittedFormData);
            }

            function processError(error) {
                alert(error.message);
            }

            $('#partner-search-submit').click(function () {   
                if (!partnerTypeVal) {                   
                    if ($('#partner-search-location').val() !== '') {
                        submittedFormEvent();
                        $('.location-error-message').hide();
                    } else {
                        $('.location-error-message').show();
                    }

                }
                else {
                    console.warn("location and partner type required");
                    if ($('#partner-search-location').val() !== '' && ($('#partner-search-partner-type').val() !== null && $('#partner-search-partner-type').val() !== '')) {
                        submittedFormEvent();
                        $('.location-error-message').hide();
                        $('.partnertype-error-message').hide();
                    } else {
                        if ($('#partner-search-location').val() == '') {
                            $('.location-error-message').show();
                        } else {
                            $('.location-error-message').hide();
                        }
                        if ($('#partner-search-partner-type').val() == null || $('#partner-search-partner-type').val() == '') {
                            $('.partnertype-error-message').show();
                        } else {
                            $('.partnertype-error-message').hide();
                        }
                    }
                }
            });

            function partnerSearchLocationInput() {
                if (territory === "AU") {
                    var australianPostalCodesRegex = /\b((0[289][0-9]{2})|([1-9][0-9]{3}))\b/;
                    var match = australianPostalCodesRegex.exec($partnerSearchLocationInput.val());

                    if (match) {
                        var postalCode = match[0];
                        $partnerSearchLocationInput.value = $partnerSearchLocationInput.val()
                            .replace(postalCode,
                                postalCode + " post code ").trim();
                        return $partnerSearchLocationInput.value;
                    } else {
                        return $partnerSearchLocationInput.val();
                    }
                }
                return $partnerSearchLocationInput.val();
            }

            function submittedFormEvent() {
                setFormDataValues();
                eventManager.trigger("partner-search-triggered", scope, submittedFormData);
                var eventSchema = findPartnerSearch.GenerateEventMetadata(scope, submittedFormData);
                tealium.event(eventSchema);
            }

            function setFormDataValues() {
                submittedFormData.location = partnerSearchLocationInput();
                submittedFormData.country = $partnerSearchCountryInput.val();
                submittedFormData.distance = $partnerSearchDistanceInput.val();
                submittedFormData.businessName = $partnerSearchBusinessNameInput.val();
                submittedFormData.partnerType = $partnerSearchPartnerTypeInput.val();
                submittedFormData.useRegionBias = useRegionBias;
            }
        }

        return function initPartnerSearch(args) {
            return args.IsExperienceEditorEditing === false
                ? new PartnerSearch(args.scope,
                    args.ContextLanguage,
                    args.IsMetric,
                    args.Metric,
                    args.MetricUnits,
                    args.Distances,
                    args.DefaultDistance,
                    args.PartnerSearchTitle,
                    args.LocationLabel,
                    args.LocationPlaceholder,
                    args.LocationValidationMessage,
                    args.PartnerTypes,
                    args.DistanceLabel,
                    args.BusinessNameLabel,
                    args.BusinessNamePlaceholder,
                    args.PartnerTypeLabel,
                    args.PartnerTypePlaceholder,
                    args.PartnerTypeValidationMessage,
                    args.PartnerTypeRequired,
                    args.SubmitButtonName,
                    args.UseMyLocationLabel,
                    args.Territory,
                    args.UseRegionBias,
                    args.CountryLabel,
                    args.Countries,
                    args.AlternateLayout)
                : null;
        };
    });
